<template>
  <div v-show="visible" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-banner">
        <h3>{{ title }}</h3>
      </div>
      <div class="header-section">
        <img :style="styleHeaderImg(currPage)" ref="headerImg" src = "../assets/art/icon_scales.png">
        <h2 v-if="panels[currPage].header">{{ panels[currPage].header }}</h2>
      </div>
      <div class="modal-body">
        <div v-if="panels[currPage].videoUrl" class="video-wrapper">
          <iframe
            :src="panels[currPage].videoUrl"
            frameborder="0"
            ref = "video"
            id = "video"
            allowfullscreen
          ></iframe>
        </div>
        <p class="description" ref="panelDescription"></p>
      </div>
      <div v-if="panels[currPage].transcript" class="transcript">
        <ExpandableBox title="Transcript" :description="panels[currPage].transcript" ref="transcript"></ExpandableBox>
      </div>
      <div v-show="panels[currPage].question" class="mcq">
          <p class="question" ref="panelQuestion"></p>
          <ol class="answer-list">
            <li 
            v-for="answer in panels[currPage].answers"
            :key="answer.title"
            class="answer-list-item"
            >
              {{ answer.description }}
            </li>
        </ol>

        <div class="feedback-container">
          <p class="feedback" ref="feedback"></p>
        </div>
        
        <div class="button-container" >
          <button 
            v-for="(answer,index) in panels[currPage].answers"
            class="place-block-button" 
            :key="answer.title"
            :data-is-correct="answer.isCorrect"
            :ref="`answer${index+1}`"
            @click="handleAnswerClick"
            >{{ answer.title }}</button>
        </div>
      </div>

      <div class="button-container nav">
        <button v-if="currPage>0" class="nav-button" @click="()=>{currPage--}" ref="back">Back</button>
        <button v-if="(currPage<panels.length-1) && (!panels[currPage].question||questionAnswered)" ref="next" class="nav-button" @click="()=>{currPage++}">Next</button>
        <button v-if="(!panels[currPage].isEnding) && (currPage==panels.length-1)" class="nav-button" ref="close" @click="closeModal">Close</button>
        <button v-if="panels[currPage].isEnding" class="nav-button" @click="restartGame" ref="restart">Restart</button>
        <button v-if="panels[currPage].isEnding" class="nav-button" @click="returnToHome" ref="finish">Finish</button>
      </div>
    </div>
  </div>
</template>

<script src="https://player.vimeo.com/api/player.js"></script>
<script>
import ExpandableBox from './ExpandableBox.vue';

const focusElements = [
  {
    ref:"finish",
    key:"x"
  },
  {
    ref:"restart",
    key:"r"
  },
  {
    ref:"close",
    key:"x"
  },
  {
    ref:"next",
    key:"ArrowRight"
  },
  {
    ref:"back",
    key:"ArrowLeft"
  },
  {
    ref:"answer3",
    key:"3"
  },
  {
    ref:"answer2",
    key:"2"
  },
  {
    ref:"answer1",
    key:"1"
  },
  {
    ref:"transcript",
    key:"t"
  },
  {
    ref:"video",
    key:" "
  },

]

export default {
  name: 'ModalPopup',
  components:{
    ExpandableBox
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      default: 'Modal Title',
    },
    imgUrl: {
      type: String,
      default: '../assets/art/blank.png',
    },
    panelData: {
      type: Array,
      default:()=>{ return [{description:"this is a description"}]},
    },
  },
  data(){
    return{
      currPage:0,
      panels:this.panelData,
      questionAnswered:false,
      focusElementIndex:-1,
      videoPaused:true
    }
  },
  emits: ['close'],
  mounted(){
    document.addEventListener("keydown",this.handleKeyDown)

  },
  unmounted(){
    document.removeEventListener("keydown",this.handleKeyDown)

  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleAnswerClick(e){
        if(e.target.getAttribute("data-is-correct")){
            this.$refs.feedback.innerHTML="Correct!";
            e.target.style.border='solid 2px green';
            this.questionAnswered = true;
        }
        else{
            e.target.style.border='solid 2px red';
            this.$refs.feedback.innerHTML="Try Again";
        }
    },
    displayDescription(){
      let description=this.panels[this.currPage].description?this.panels[this.currPage].description:''
      description=description.replaceAll(('\n'), ('<br><br>'))
      this.$refs.panelDescription.innerHTML=description
    },
    displayQuestion(){
      if(this.panels[this.currPage].question){
        let question=this.panels[this.currPage].question
        this.$refs.panelQuestion.innerHTML = question
      }
    },
    styleHeaderImg(page){
      if(page<this.panels.length-1){
        return {display:'none'}
      }
      else{
        return {display:'block'}
      }
    },
    restartGame(){
      window.location.reload()
    },
    returnToHome(){
      window.location.href = "/"
    },
    incrementFocus(){

      function incrementIndex(index){
        index++;
        if(index>=focusElements.length){
          index=0
        }
        return index
      }


      let focusEl = null


      if(this.focusElementIndex>=0){
        focusEl =this.$refs[focusElements[this.focusElementIndex].ref].$el || this.$refs[focusElements[this.focusElementIndex].ref]
        focusEl = Array.isArray(focusEl)?focusEl[0]:focusEl
        console.log('focusEl',focusEl)
        focusEl.style.border = 'none'
      }
      
      this.focusElementIndex=incrementIndex(this.focusElementIndex)

      let numIncrements = 1
      while((!this.$refs[focusElements[this.focusElementIndex].ref]||((Array.isArray(this.$refs[focusElements[this.focusElementIndex].ref]))&&this.$refs[focusElements[this.focusElementIndex].ref].length==0))&&numIncrements<=focusElements.length){
        this.focusElementIndex=incrementIndex(this.focusElementIndex)
        
        numIncrements++;
        if(numIncrements>=focusElements.length){
          console.log('no focus elements found')

        }
      }
      console.log(this.focusElementIndex)
      focusEl = this.$refs[focusElements[this.focusElementIndex].ref].$el || this.$refs[focusElements[this.focusElementIndex].ref]
      focusEl = Array.isArray(focusEl)?focusEl[0]:focusEl
      console.log('focusEl',focusEl)
      focusEl.style.border = '4px solid cyan'

    },
    decrementFocus(){
      function decrementIndex(index){
        index--;
        if(index<0){
          index=focusElements.length-1
        }
        return index
      }

      let focusEl = null


      if(this.focusElementIndex>=0){
        focusEl =this.$refs[focusElements[this.focusElementIndex].ref].$el || this.$refs[focusElements[this.focusElementIndex].ref]
        focusEl = Array.isArray(focusEl)?focusEl[0]:focusEl
        console.log('focusEl',focusEl)
        focusEl.style.border = 'none'
      }
      
      this.focusElementIndex=decrementIndex(this.focusElementIndex)

      let numIncrements = 1
      //  (!exists ||(array and array is empty)) and not full loop
      while((!this.$refs[focusElements[this.focusElementIndex].ref]||((Array.isArray(this.$refs[focusElements[this.focusElementIndex].ref]))&&this.$refs[focusElements[this.focusElementIndex].ref].length==0))&&numIncrements<=focusElements.length){
        this.focusElementIndex=decrementIndex(this.focusElementIndex)

        numIncrements++;
        if(numIncrements>=focusElements.length){
          console.log('no focus elements found')

        }
      }
      console.log(this.focusElementIndex)
      
      focusEl = this.$refs[focusElements[this.focusElementIndex].ref].$el || this.$refs[focusElements[this.focusElementIndex].ref]
      focusEl = Array.isArray(focusEl)?focusEl[0]:focusEl
      console.log('focusEl',focusEl)
      focusEl.style.border = '4px solid cyan'

    },
    toggleVideo(){
      const videoPlayer = new Vimeo.Player('video')
            
      if(this.videoPaused){
        this.videoPaused=false;
        videoPlayer.play().then(function() {
            // the video was played
            
        }).catch(function(error) {
          console.log(error)
            switch (error.name) {
                case 'PasswordError':
                    // the video is password-protected and the viewer needs to enter the
                    // password first
                    break;

                case 'PrivacyError':
                    // the video is private
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });
      }
      else{
        this.videoPaused=true;
        videoPlayer.pause().then(function() {
            // the video was paused
            
        }).catch(function(error) {
          console.log(error)
            switch (error.name) {
                case 'PasswordError':
                    // the video is password-protected and the viewer needs to enter the
                    // password first
                    break;

                case 'PrivacyError':
                    // the video is private
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });
      }
    },
    activateFocusElement(){
      if(focusElements[this.focusElementIndex].ref=="video"){
        console.log('toggling video')
        this.toggleVideo()
      }
      else{
        let focusEl = this.$refs[focusElements[this.focusElementIndex].ref].$el || this.$refs[focusElements[this.focusElementIndex].ref]
        focusEl = Array.isArray(focusEl)?focusEl[0]:focusEl
        console.log('focusEl',focusEl)
        console.log('dispatching keydown : ',focusElements[this.focusElementIndex].key)
        focusEl.style.border = 'none'
        document.dispatchEvent(new KeyboardEvent('keydown', {'key': focusElements[this.focusElementIndex].key}));
      }
    },
    handleKeyDown(e){
      if(!this.visible){return}
      switch(e.key){
        case "x":
        case "Escape":
          if((!this.panels[this.currPage].isEnding) && (this.currPage==this.panels.length-1)){
            this.closeModal()
          }
          else if(this.panels[this.currPage].isEnding){
            this.returnToHome()
          }
          break;
        case "ArrowRight":
        case "PageUp":
          if((this.currPage<this.panels.length-1) && (!this.panels[this.currPage].question||this.questionAnswered)){
            this.currPage++;
          }
          else if(this.currPage===this.panels.length-1){
            if(!this.panels[this.currPage].isEnding){
              this.closeModal()
            }
            else{
              this.returnToHome()
            }
          }
          break;
        case "ArrowLeft":
        case "PageDown":
          if(this.currPage>0){
            this.currPage--;
          }
          break;
        case "t":
          if(this.panels[this.currPage].transcript){
            this.$refs.transcript.toggleExpanded()
          }
          break;
        case "a":
        case "1":
          if(this.panels[this.currPage].answers && this.panels[this.currPage].answers[0]){
            this.$refs['answer1'][0].click()
          }
          break;
        case "b":
        case "2":
          if(this.panels[this.currPage].answers && this.panels[this.currPage].answers[1]){
            this.$refs['answer2'][0].click()
          }
          break;
        case "c":
        case "3":
          if(this.panels[this.currPage].answers && this.panels[this.currPage].answers[2]){
            this.$refs['answer3'][0].click()
          }
          break;
        case " ":
          if(this.focusElementIndex>=0){
            console.log('activating focus element')
            this.activateFocusElement()
          }
          else if(this.panels[this.currPage].videoUrl){
            console.log('toggling video')
            this.toggleVideo()
          }
          break;
        case "r":
          if(this.panels[this.currPage].isEnding){
            this.restartGame()
          }
          break;
        case "ArrowUp":
        case "w":
          this.incrementFocus()
          break;
        case "ArrowDown":
        case "s":
          this.decrementFocus();
          break;
        case "Enter":
          if(this.focusElementIndex>=0){
            this.activateFocusElement()
          }
          break;
      }
    }
  },
  computed: {
    
  },
  watch:{
    currPage(){
      //reset keyboard focus
      this.focusElementIndex=-1
      this.videoPaused=true

      for(let refIndex=0;refIndex<focusElements.length;refIndex++){
        if(!this.$refs[focusElements[refIndex].ref]){continue;}
        let focusEl =this.$refs[focusElements[refIndex].ref].$el || this.$refs[focusElements[refIndex].ref]
        focusEl = Array.isArray(focusEl)?focusEl[0]:focusEl
        //console.log('focusEl',focusEl)
        if(focusEl){
          focusEl.style.border = 'none'
        }
        
      }

      console.log('refs:',this.$refs)
      if(this.panels[this.currPage].videoUrl){
        setTimeout(() => {
          const videoPlayer = new Vimeo.Player('video');
          videoPlayer.on('play',function(){
            this.videoPaused=false
            console.log('playing video: video paused = ',this.videoPaused)
          });
          videoPlayer.on('pause',function(){
            this.videoPaused=true
            console.log('pausing video')
          });
        }, 250);
      }
      this.displayDescription()
      this.displayQuestion()
      if(this.currPage==this.panels.length-1){
        setTimeout(
          ()=>{
            this.$refs.headerImg.style.transform='scale(1)'
          },
          250
        )
      }
    },
    visible(){
      this.displayDescription()
      this.displayQuestion()
    }
  },

};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 3px;
  width: 90%;
  max-width: 1000px;
  overflow: hidden;
  position: relative;
  padding: 0;
}

.modal-banner {
  background-image: url('../assets/art/popup_header03.png');
  height: 50px;
  position: relative;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.modal-banner h3{
    margin-left:3%;
    position:static;
    color:black;
}


.close-button {
  position: static;
  margin-right:20px;
  font-size: 24px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

.close-button img{
  width:13px;
}

.modal-title {
  text-align: center;
  margin: 16px 0;
  font-size: 24px;
}

.modal-body {
    padding: 0 20px 20px;

    display:flex;
    flex-flow: row nowrap;
    gap: 1rem;
}

.img-wrapper {
    width:100%
}

.img-wrapper img {
  width: 100%;
  height: 315px;
}

.video-wrapper {
    width:100%;
    position:relative;
}

.video-wrapper iframe {
  position:absolute;
  top:0;
  width: 100%;
  height:100%;
}

.description, .question {

  font-size: 1rem;
  width:80%;
  margin:0 auto;
}

.description p {
  margin-bottom:0px;
}
.place-block-button {
    display: block;
    margin: 0 auto 20px;
    background-color: #9F7039;
    color: white;
    border: none;
    padding: 7px 60px;
    font-size: 1.1rem;
    cursor: pointer;
    border-radius: 16px;
    transition: background-color 0.3s ease;
    font-family: Verdaguera, serif;
}
.nav-button {
    display: block;
    margin:20px 0;
    background-color: #4a2a00;
    color: white;
    border: none;
    padding: 7px 60px;
    font-size: 1.1rem;
    cursor: pointer;
    border-radius: 16px;
    transition: background-color 0.3s ease;
    font-family: Verdaguera, serif;
}

.header-section{
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-items: center;
    padding:10px;


}

.button-container {
    display: flex;
    flex-flow: row nowrap;
    gap: 30px;
    justify-content: center;

}

.mcq{
  margin:0 20px;
}

.answer-list{
  list-style-type: upper-latin;
  margin-left:12%;
  font-weight:450;
  margin-bottom:2rem;
  width:70%;
}

.answer-list-item::marker{
  font-weight: bolder;
  font-size:1.1rem;
}

.header-section img{
  width:120px;
  transform:scale(0);
  transition: transform 0.75s;
}

.feedback-container{
  margin:auto
}
.feedback{
  text-align: center;
}
.transcript{
  margin:auto;
  width:80%;
}



</style>
